/* eslint-disable */
// import { Switch } from "@material-ui/core";
import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { ProductLensTypeListSortField } from "@saleor/productLensType/urls";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import {
  ProductLensTypeListPath,
  ProductLensTypeListUrlQueryParams
} from "./urls";

import ProductLensTypeListComponent from "./views/ProductLensTypeList";

const ProductLensTypeList: React.FC<RouteComponentProps<{}>> = ({
  location
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: ProductLensTypeListUrlQueryParams = asSortParams(
    qs,
    ProductLensTypeListSortField
  );
  return <ProductLensTypeListComponent params={params} />;
};

export const ProductLensTypeSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.productLensType)} />
      <Switch>
        <Route
          exact
          path={ProductLensTypeListPath}
          component={ProductLensTypeList}
        />
      </Switch>
    </>
  );
};

export default ProductLensTypeSection;
